import clsx from "clsx";

interface Props {
  title: string;
  count: number;
  justifyNumberRight?: boolean;
}

export const Stat = ({ title, count, justifyNumberRight = false }: Props) => {
  return (
    <div>
      <div
        className={clsx("text-2xs font-semibold mb-2", {
          "text-right": justifyNumberRight,
        })}
      >
        {title}
      </div>
      <div
        className={clsx("flex items-center", {
          "justify-between": !justifyNumberRight,
          "justify-end": justifyNumberRight,
        })}
      >
        <div
          className={clsx(
            "h-6 text-lg font-semibold flex items-center text-ellipsis",
            {
              "justify-center": !justifyNumberRight,
              "justify-end": justifyNumberRight,
            },
          )}
        >
          {count}
        </div>
      </div>
    </div>
  );
};
